import React from 'react';

const ChatIcon = ({ onClick, hasNewMessage = false, messageCount = 0 }) => {
  return (
    <div className="chat-icon-container" onClick={onClick}>
      <div className="chat-icon">
        💬
      </div>
      {hasNewMessage && messageCount > 0 && (
        <div className="chat-notification-badge">
          {messageCount > 99 ? '99+' : messageCount}
        </div>
      )}
    </div>
  );
};

export default ChatIcon;
